import {
  withStyles,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox,
  CheckboxProps,
} from '@material-ui/core';

import React, {
  ReactNode,
  useState,
  useEffect,
  useRef,
  MutableRefObject,
} from 'react';

// onchange example----------------------------------------------------
// export const RadioInputChange = UpdateData => (e, value: string) => {
//     UpdateData({ [e.target.name]: value });
// }

// const----------------------------------------------------
export const EmptyCheckboxMsg = '如果你要繼續執行，請勾選這個核取方塊。';

// style----------------------------------------------------
export const StyleFormControl = withStyles(() => ({
  root: {
    padding: '5px',
  },
}))(FormControl);

export const StyleFormHelperText = withStyles(() => ({
  root: {
    margin: '0',
  },
}))(FormHelperText);

interface ICheckbox extends Omit<CheckboxProps, 'inputRef'> {
  label?: ReactNode;
  inputRef?: MutableRefObject<HTMLInputElement | undefined>;

  verifyBeforeChange?: boolean;
  error?: boolean;
  helperText?: ReactNode;
}

// component----------------------------------------------------
const CheckBox = (props: ICheckbox): JSX.Element => {
  const {
    checked,
    inputRef = useRef(),
    verifyBeforeChange = false,
    error,
    helperText,
    label,
    ...other
  } = props;
  const [message, setMessage] = useState('');
  const [FirstVerify, setFirstVerify] = useState(verifyBeforeChange);

  useEffect(() => {
    // 始設畫面預設不 verify , 除非 verifyBeforeChange = true
    if (!FirstVerify) {
      setFirstVerify(true);
      setMessage('');
      return;
    }

    // 驗 HTML validation
    if (inputRef.current) {
      const { validationMessage } = inputRef.current;
      if (validationMessage.length > 0) {
        setMessage(validationMessage);
        return;
      }
    }

    // 先前檢驗都 pass
    setMessage('');
  }, [checked, verifyBeforeChange]);

  return (
    <StyleFormControl error={error || message.length > 0}>
      <FormControlLabel
        inputRef={inputRef}
        control={<Checkbox checked={checked} {...other} />}
        label={label}
      />
      <StyleFormHelperText>{helperText || message}</StyleFormHelperText>
    </StyleFormControl>
  );
};

export default CheckBox;
